// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"161":"ebc3006c","614":"33d409de","828":"c56928d7"}[chunkId] + ".chunk.css";
};